module.exports = {
    "breadcrumbs": `\u{D0D0}\u{C0C9} \u{D45C}\u{C2DC}`
};


//# sourceMappingURL=ko-KR.main.js.map
